// Global form constants

// Rating option interface
export interface RatingOption {
  value: number;
  label: string;
}

export const RATING_OPTIONS: readonly RatingOption[] = [
  { value: 1, label: "1 звезда" },
  { value: 2, label: "2 звезды" },
  { value: 3, label: "3 звезды" },
  { value: 4, label: "4 звезды" },
  { value: 5, label: "5 звезд" },
] as const;

// Source option interface
export interface SourceOption {
  value: string;
  label: string;
}

export const SOURCE_OPTIONS: readonly SourceOption[] = [
  { value: "google", label: "Google" },
  { value: "yandex", label: "Yandex" },
  { value: "website", label: "Website" },
  { value: "avito", label: "Avito" },
] as const;

// Role option interface
export interface RoleOption {
  value: string;
  label: string;
}

export const ROLE_OPTIONS: readonly RoleOption[] = [
  { value: "client", label: "Клиент" },
  { value: "partner", label: "Партнер" },
  { value: "expert", label: "Эксперт" },
  { value: "tenant", label: "Арендатор" },
] as const;

// Type for rating values
export type RatingValue = (typeof RATING_OPTIONS)[number]["value"];

// Type for source values
export type SourceValue = (typeof SOURCE_OPTIONS)[number]["value"];

// Type for role values
export type RoleValue = (typeof ROLE_OPTIONS)[number]["value"];
